// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__M6bL9","gradient":"styles_gradient__rTOsl","object":"styles_object__Gp9bM"};